// Compliance.js
// ============================================================================
// LEGAL REVIEW REQUIRED - REGULATORY POSITION UNCONFIRMED
// Ivipass has not confirmed what licences, registrations or regulator listings
// it holds (for example OISC / IAA registration for immigration advice, or any
// education-agent accreditation). The wording below has been written so that it
// asserts NO licence, registration, accreditation or regulated status of any
// kind. It must be reviewed by the company and, ideally, by a solicitor before
// publication, and updated once the real regulatory position is known.
// ============================================================================
import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, Shield } from 'lucide-react';

const Compliance = () => {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            How We Operate
          </h2>
        </motion.div>

        {/* Compliance Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Card 1 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <FileCheck size={24} className="text-blue-600" />
                </div>
              </div>
              <div>
                <h3 className="text-base font-semibold text-primary mb-2">
                  Advice and Application Support
                </h3>
                <p className="text-sm text-gray-600 font-light leading-relaxed">
                  Ivipass helps people understand their options and prepare their applications. We do not decide who is admitted or who is hired. Those choices belong entirely to the university or the employer concerned.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <Shield size={24} className="text-green-600" />
                </div>
              </div>
              <div>
                <h3 className="text-base font-semibold text-primary mb-2">
                  Payments Made Direct
                </h3>
                <p className="text-sm text-gray-600 font-light leading-relaxed">
                  Course fees, wages and anything set out in an employment contract pass directly between you and the institution or employer. Ivipass takes no tuition money and handles nobody else&apos;s payroll.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
